import React from "react";
import PlatHitam from "../../assets/plat_galbanil.jpg";
import PlatHitamPhone from "../../assets/platHitamYa.jpg";

const Header = () => {
  return (
    <>
      {/* PC FORMAT */}
      <section className="container-screen sm:grid grid-cols-5 py-12 hidden">
        <div className="h-[350px] w-[350px] overflow-hidden rounded-lg col-span-2">
          <img src={PlatHitam} className="h-full w-full" />
        </div>
        <div className="flex flex-col justify-center col-span-3">
          <h1 className="text-4xl font-helvetica text-primaryPandawa text-left tracking-wide">
            PLAT GALVANIL
          </h1>
          <h2 className="text-xl font-helvetica text-primaryPandawa text-left mt-2 pl-1">
            {"[ Galvanneal Sheet ]"}
          </h2>
          <p className="pl-1 text-justify font-montserrat text-lg mt-4">
            Plat Galvanil adalah lembaran baja yang dilapisi seng dan kemudian
            mengalami proses pemanasan (annealing) untuk membentuk lapisan
            paduan seng-besi. Proses ini menghasilkan permukaan yang lebih
            keras, tahan karat, dan memiliki daya lekat cat yang sangat baik.
            Plat ini banyak digunakan dalam industri otomotif, peralatan rumah
            tangga, dan aplikasi struktural yang membutuhkan ketahanan terhadap
            korosi dan kemudahan pengecatan.
          </p>
        </div>
      </section>

      {/* MOBILE FORMAT */}
      <section className="sm:hidden">
        <div className="h-24 overflow-hidden">
          <img src={PlatHitamPhone} />
        </div>
        <div className="container-screen py-10">
          <h1 className="font-helvetica text-2xl text-primaryPandawa tracking-widest">
            PLAT GALVANIL
          </h1>
          <h2 className="font-montserrat font-[700] text-sm text-primaryPandawa">
            {"[ Galvanneal Sheet  ]"}
          </h2>
          <p className="font-montserrat text-justify mt-4">
            Plat Galvanil adalah lembaran baja yang dilapisi seng dan kemudian
            mengalami proses pemanasan (annealing) untuk membentuk lapisan
            paduan seng-besi. Proses ini menghasilkan permukaan yang lebih
            keras, tahan karat, dan memiliki daya lekat cat yang sangat baik.
            Plat ini banyak digunakan dalam industri otomotif, peralatan rumah
            tangga, dan aplikasi struktural yang membutuhkan ketahanan terhadap
            korosi dan kemudahan pengecatan.
          </p>
        </div>
      </section>
    </>
  );
};

export default Header;
